import { render } from "./ProduitTransportLocation.vue?vue&type=template&id=7b3d3f3c&ts=true"
import script from "./ProduitTransportLocation.vue?vue&type=script&lang=ts"
export * from "./ProduitTransportLocation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__